<template>
  <div class="sky-change-item-detail wsp-padding-left-12">
    <div class="page-content-loading sky-page-content" v-if="loading">
      <sk-icon-status type="ing" content="智能分析中,请稍等..."></sk-icon-status>
    </div>
    <div v-else class="sky-page-content">
      <div>
        <div>
          <div class="wsp-sub-group-title">
            <div class="wsp-group-sub-title-icon"></div>
            <div class="wsp-group-sub-title-value">
              <span style="color: chocolate;"
                >温馨提示：以下是场景推荐的所有服务器计算结果，可选择一个最有性价比的套餐配置</span
              >
              {{ specName }} （<span class="title-tip">注：黄色背景代表服务器CPU不满足相应要求</span>）
            </div>
          </div>
          <div>
            <div v-if="contentList && contentList.length > 0">
              <el-table
                :data="contentList"
                :border="true"
                :show-header="true"
                v-model="selectedRow"
                :cell-class-name="changeCellClassName"
                :row-class-name="tableRowClassName"
                :column-drag-sortable="false"
                class="sk-customize-cell-hight table-detail-content "
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="radio" :selectable="selectable" header-align="center" width="40" />
                <el-table-column label="备注" header-align="center" width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.hasSupport">套餐{{ scope.$index + 1 }}</span>
                    <span v-else>{{ scope.row.hasSupportDesc }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="服务器名称" header-align="center" prop="serverName" width="150">
                  <!-- <template slot-scope="scope">
                    <el-tag v-if="scope.row.change" type="danger">{{ scope.row.itemName }}</el-tag>
                    <span v-else>{{ scope.row.itemName }}</span>
                  </template> -->
                </el-table-column>
                <el-table-column label="实际节点数量" header-align="center" prop="calculateServerNum" width="120" />
                <el-table-column label="推荐节点数量" header-align="center" prop="recommendServerNum" width="120" />
                <el-table-column label="CPU型号" header-align="center" prop="cpuName" width="350" />
                <el-table-column label="CPU数量" header-align="center" prop="cpuNum" width="70" />
                <el-table-column label="CPU主频" header-align="center" prop="cpuSpeed" width="70" />
                <el-table-column label="显卡名称" header-align="center" prop="gpuName" width="90" />
                <el-table-column label="显卡数量" header-align="center" prop="gpuNum" width="70" />
                <el-table-column label="内存规格" header-align="center" prop="memorySpecDesc" width="70" />
                <el-table-column label="内存数量" header-align="center" prop="memoryNum" width="70" />
                <el-table-column label="服务器磁盘信息" header-align="center" prop="diskInfoList">
                  <template slot-scope="scope">
                    <span style="line-height: 10px!important">
                      <span
                        v-for="(diskInfo, index) in scope.row.diskInfoList"
                        :key="index"
                        style="line-height: 10px!important"
                      >
                        {{ diskInfo }}
                      </span>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: center; margin-top: 10px;">
      <el-button type="primary" @click="onConfirm">确定</el-button>
      <el-button class="el-button filter-item el-button--default el-button--mini" @click="onCancel" size="mini"
        >返回</el-button
      >
    </div>
  </div>
</template>
<script>
import { Button, Card, Table, TableColumn, Tag, Select, Option } from 'element-ui'

import { SkIconStatus } from 'sk-ui'

import { calServerResourceBySegmentScene } from '@/api/calculator'

export default {
  name: 'SkyCalServerListDetail',
  components: {
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [SkIconStatus.name]: SkIconStatus
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      contentList: [],
      relationList: [],
      loading: true,
      specName: '',
      selectedRow: null
    }
  },
  mounted() {
    calServerResourceBySegmentScene(this.data)
      .then(res => {
        //计算完
        this.loading = false
        this.contentList = res.data.content
      })
      .catch(e => {
        this.loading = false
        throw e
      })
  },
  methods: {
    handleSelectionChange(row) {
      this.selectedRow = row
    },
    onConfirm() {
      if (this.selectedRow === null) {
        this.$store.dispatch('OpenNotification', { message: '请选择一个套餐配置', type: 'error' })
        return
      }
      this.$emit('confirm', { data: this.selectedRow })
    },
    onCancel() {
      this.$emit('cb')
    },
    selectable(row) {
      return row.hasSupport
    },
    tableRowClassName({ row, rowIndex }) {
      if (!row.hasSupport) {
        return 'warning-row'
      }
    },
    changeCellClassName(row, column, rowIndex, columnIndex) {
      if (row.row.change) {
        if (row.columnIndex === 1) {
          return 'cell-before-data'
        }
        if (row.columnIndex === 2) {
          return 'bg-3bb113'
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(change-item-detail) {
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #cccccc;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #999999;
  }
  .title-tip {
    font-weight: bold;
    color: red;
  }
  .sky-page-content {
    overflow-y: scroll;
    height: 75vh;
  }
  .page-content-loading {
    padding-left: 20px;
    padding-top: 20px;
  }
  .table-detail-content {
    .cell {
      word-break: break-all;
      white-space: break-spaces;
    }
    .cell-before-data {
      .cell {
        text-decoration: line-through;
      }
    }
  }
  .el-table__body-wrapper .full-value-content {
    padding: 0 !important;
  }
  .el-table__body-wrapper .full-value-content .cell {
    padding: 0 !important;
    min-height: 33px !important;
    .full-content {
      width: 100%;
      height: 100%;
    }
  }
  .page-content-item {
    padding-left: 18px;
  }
  .poc-scene-research-content {
    .scene-item {
      .scene-item-name {
        line-height: 28px;
        border-radius: 6px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        padding: 2px 18px;
      }
    }
  }
  .poc-base-detail-content {
    line-height: 28px;
    .base-detail-attr-item div {
      display: inline-block;
    }
    .base-detail-attr-item .attr-label {
      text-align: right;
    }
  }
}
</style>
